/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A dependent task that requires this one to succeed.
 * Represented by either task_id or pod_name.
 * @export
 * @interface PipelineTaskDetailChildTask
 */
export interface PipelineTaskDetailChildTask {
  /**
   * System-generated ID of a task.
   * @type {string}
   * @memberof PipelineTaskDetailChildTask
   */
  task_id?: string;
  /**
   * Name of the corresponding pod assigned by the orchestration engine.
   * Also known as node_id.
   * @type {string}
   * @memberof PipelineTaskDetailChildTask
   */
  pod_name?: string;
}

/**
 * Check if a given object implements the PipelineTaskDetailChildTask interface.
 */
export function instanceOfPipelineTaskDetailChildTask(
  value: object,
): value is PipelineTaskDetailChildTask {
  return true;
}

export function PipelineTaskDetailChildTaskFromJSON(json: any): PipelineTaskDetailChildTask {
  return PipelineTaskDetailChildTaskFromJSONTyped(json, false);
}

export function PipelineTaskDetailChildTaskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PipelineTaskDetailChildTask {
  if (json == null) {
    return json;
  }
  return {
    task_id: json['task_id'] == null ? undefined : json['task_id'],
    pod_name: json['pod_name'] == null ? undefined : json['pod_name'],
  };
}

export function PipelineTaskDetailChildTaskToJSON(json: any): PipelineTaskDetailChildTask {
  return PipelineTaskDetailChildTaskToJSONTyped(json, false);
}

export function PipelineTaskDetailChildTaskToJSONTyped(
  value?: PipelineTaskDetailChildTask | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    task_id: value['task_id'],
    pod_name: value['pod_name'],
  };
}
